module.exports = __webpack_public_path__ + "media/images/csat-course-f736b8d1.jpg";